import * as types from "../../types";
export const selectCampaignRequest = ({ campaign }) => {
  return {
    type: types.SELECT_CAMPAIGN,
    payload: { campaign },
  };
};
